import EngineInformation from "./EngineInformation";
import TechnicalRecords from "./TechnicalRecords";
import EngineCondition from "./EngineCondition";
import EngineStand from "./EngineStand";
import PowerPlant from "./PowerPlant";
import FleetComposition from "./FleetComposition";
import TechnicalSummary from "./TechnicalSummary";
import InstalledEngine from "./InstalledEngine";
import PhysicalReview from "./PhysicalReview";
import MliTab from "./MliTab";
import ExportDialog from "./ExportDialog";
export {
    EngineInformation,
    TechnicalRecords,
    EngineCondition,
    EngineStand,
    PowerPlant,
    FleetComposition,
    TechnicalSummary,
    InstalledEngine,
    PhysicalReview,
    MliTab,
    ExportDialog
}

export const gtalable_dropdownField =
    [{ lable: "aware that SAEL's engine was leased.", value: 'is_aware', dropdown: ['were', 'were not'] },
    { lable: "familiar with the current condition of the engine.", value: "is_corrent_condition", dropdown: ['were', 'were not'] },
    { lable: "PMA parts in the gaspath.", value: "is_pma", dropdown: ['uses', 'does not use'] },
    { lable: "DER repairs.", value: "is_der", dropdown: ['uses', 'does not use'] },
    { lable: "familiar with the shop visit provisions in the lease.", value: "is_shop_visit", dropdown: ['were', 'were not'] },
    { lable: "familiar with the redelivery conditions in the lease.", value: "is_redelivery", dropdown: ['were', 'were not'] },
    { lable: "familiar with replacement parts clause in the lease.", value: "is_replacement", dropdown: ['were', 'were not'] },
    { lable: "aware that a QEC was delivered with the engine.", value: "is_qec", dropdown: ['were', 'were not'] },
    { lable: "aware that a transportation stand was delivered.", value: "is_transportation", dropdown: ['were', 'were not'] },
    ]

export const engineConditionConfig = [
    { description: 'Fan Case', conditionKey: 'fan_case', noteKey: 'fan_case', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Blade', conditionKey: 'fan_blade', noteKey: 'fan_blade', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Inlet', conditionKey: 'fan_inlet', noteKey: 'fan_inlet', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Rotation of Spools', conditionKey: 'rotation_of_spools', noteKey: 'rotation_of_spools', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Evidence -Leakage', conditionKey: 'evidence_leakage', noteKey: 'evidence_leakage', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Exhaust Area', conditionKey: 'exhaust_area', noteKey: 'exhaust_area', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Spotcheck LRU S/N', conditionKey: 'spotcheck_lru_sn', noteKey: 'spotcheck_lru_sn' },
    { description: 'Photo', conditionKey: 'photo_condition', noteKey: 'photo_note', message: "To obtain and attach photos of the engine (if possible)" }
];
export const engineRemovedConfig = [
    { description: 'Fan Case', conditionKey: 'fan_case', noteKey: 'fan_case', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Blade', conditionKey: 'fan_blade', noteKey: 'fan_blade', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Fan Inlet', conditionKey: 'fan_inlet', noteKey: 'fan_inlet', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Rotation of Spools', conditionKey: 'rotation_of_spools', noteKey: 'rotation_of_spools', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Core Area', conditionKey: 'core_area', noteKey: 'core_area', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Evidence -Leakage', conditionKey: 'evidence_leakage', noteKey: 'evidence_leakage', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Exhaust Area', conditionKey: 'exhaust_area', noteKey: 'exhaust_area', dropdown: ['Satisfied', 'Not satisfied'] },
    { description: 'Spotcheck LRU S/N', conditionKey: 'spotcheck_lru_sn', noteKey: 'spotcheck_lru_sn' },
    { description: 'Tag', conditionKey: 'removed_engine_tag', noteKey: 'removed_engine_tag',},
    { description: 'Photo', conditionKey: 'photo_condition', noteKey: 'removed_engine_photo_availability', message: "To obtain and attach photos of the engine (if possible)" }
];


